import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import dividerSvg from '../../divider.svg';
import starterSvg from '../../assets/images/start.svg';

class Step1 extends Component {
    render() {
        const { start } = this.props.questionOptions;
        return (
            <Fragment>
                <img src={starterSvg} className="overlay-image" alt="Speech bubbles icon reflects available interactive guide"/>
                <div className="form-group ddg-start">
                    <div className="grid">
                        <div className="row">
                            <div className="col-lg-12">
                                <h2 style={{fontSize: "24px"}}>Your Symptom Discussion Guide</h2>
                                <p>Whether you are experiencing PD-related hallucinations and delusions, or caring for someone who is, it can be difficult to know what to share with your healthcare provider. To help you prepare for the discussion, consider completing the interactive guide below or <a href="/pdf/symptom-discussion-guide.pdf" target="_blank">download the discussion guide</a> and bring it along to your next doctor's appointment.</p>
                                <h2 style={{fontSize: "24px"}}>Please read the following questions and answer all that apply.</h2>
                                <img src={dividerSvg} alt="divider" />
                                <div className="row">
                                    <div className="col-lg-12">
                                        <button
                                            className={"btn btn-primary btn-lg w-auto text-center wide-mobile "  + (start === "yes" ? "active" : "")}
                                            type="submit"
                                            onClick={(e) => this.props.questionAnswer("start", "yes")}
                                        >
                                            <b>Start</b>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}


const mapStateToProps = (state) => {
    const { questionOptions } = state;
    return { questionOptions: questionOptions };
}

export default connect(mapStateToProps, actions)(Step1);